export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Agenda.vue?vue&type=template&id=6b9aa9f8&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Boek/Agenda.vue?vue&type=template&id=6b9aa9f8&
// module id = 342
// module chunks = 0